import { defineComponent, ref, computed } from 'vue';
import __vue_component__ from './ResizeObserver.vue.js';

var script = defineComponent({
    name: 'TransitionOnResize',
    components: {
        ResizeObserver: __vue_component__,
    },
    model: {
        prop: 'dimensions',
        event: 'update:dimensions',
    },
    props: {
        containerComponent: {
            type: [Object, String],
            default: 'div',
        },
        dimensions: {
            type: Object,
            required: false,
            default: () => ({ height: 0, width: 0 }),
        },
        transitionDuration: {
            type: Number,
            required: false,
            default: 150,
        },
    },
    setup(props, { emit }) {
        const contentHeight = ref(0);
        const contentWidth = ref(0);
        const onResize = (dimensions) => {
            contentHeight.value = dimensions.height;
            contentWidth.value = dimensions.width;
            emit('update:dimensions', dimensions);
        };
        const style = computed(() => ({
            minHeight: `${contentHeight.value}px`,
            maxHeight: `${contentHeight.value}px`,
            minWidth: `${contentWidth.value}px`,
            maxWidth: `${contentWidth.value}px`,
            transitionDuration: `${props.transitionDuration}ms`,
        }));
        const containerComponentLocal = computed(() => {
            if (typeof props.containerComponent === 'string') {
                return props.containerComponent;
            }
            return props.containerComponent.component;
        });
        const containerComponentProps = computed(() => {
            if (typeof props.containerComponent === 'string') {
                return {};
            }
            return props.containerComponent.props;
        });
        return {
            contentHeight,
            contentWidth,
            onResize,
            style,
            containerComponentLocal,
            containerComponentProps,
        };
    },
});

export { script as default };
